import { Button, EEditorType, Overlay, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import BeeEditor from "."
import "./styles.scss"
import { EEditorCssFileName } from "./types"

export function FileManagerOverlay({ hidden, toggleFileManager, handleFileInsert }: { hidden?: boolean, toggleFileManager: () => void, handleFileInsert: (file: any) => void }) {
    const { t } = useTranslation()

    function handleToggleFileManager() {
        toggleFileManager()
    }

    return <Overlay
        open
        className={hidden ? "hidden fileManagerOverlay" : "fileManagerOverlay"}
        heading={{
            titleContent: <Typography variant="title" >{t("file-manager-title")}</Typography>,
            actions: [
                <Button key="close" color="shade150" onClick={handleToggleFileManager} >
                    {t("general-close")}
                </Button>
            ]
        }}
        content={
            <BeeEditor
                key="fileManagerEditor"
                cssFileName={EEditorCssFileName.fileManagerOverlay}
                className="beeFileManager"
                variant="inline"
                editorType={EEditorType.fileManager}
                onFilePickerInsert={handleFileInsert}
            />
        }
    />
}